import React from 'react';
import AthleteProfile from './common/AthleteProfile';
const SignIn = React.lazy(() => import('./beforeLogin/SignIn'));
// const SignUp = React.lazy(() => import("./beforeLogin/SignUp"));
const ForgotPassword = React.lazy(() => import('./beforeLogin/ForgotPassword'));
const PublicBooking = React.lazy(() => import('./afterLogin/PublicBooking'));
const ClientDashboard = React.lazy(() => import('./afterLogin/ClientDashboard'));
const ConfirmBookingPage = React.lazy(() => import('./afterLogin/ConfirmBookingPage'));
const Booking = React.lazy(() => import('./afterLogin/Booking'));
const RescheduleAppointment = React.lazy(() => import('./afterLogin/RescheduleAppointment'));
const FamilyMembers = React.lazy(() => import('./afterLogin/FamilyMembers'));
const PaymentPage = React.lazy(() => import('./afterLogin/PaymentPage'));
const Favorites = React.lazy(() => import('./afterLogin/Favorites'));
const SavedCards = React.lazy(() => import('./afterLogin/SavedCards'));
const Credits = React.lazy(() => import('./afterLogin/Credits'));
const Orders = React.lazy(() => import('./afterLogin/Orders'));

const Explore = React.lazy(() => import('./afterLogin/Explore'));
const Details = React.lazy(() => import('./afterLogin/Details'));
const Waiver = React.lazy(() => import('./common/Waiver'));
const PostBookingConfirmation = React.lazy(() => import('./afterLogin/PostBookingConfirmation'));
const InstallmentsCardUpdate = React.lazy(() =>
  import('./Others/InstallmentsCardUpdate/CardUpdate')
);
const CheckIn = React.lazy(() => import('./Others/CheckIn'));
const MemberRegistration = React.lazy(() => import('./Others/MemberRegistration'));
const MemberRegistrationCreateForm = React.lazy(() =>
  import('./Others/MemberRegistration/MemberRegistrationCreateForm')
);
const MemberQuestionnaire = React.lazy(() =>
  import('./Others/MemberQuestionnaire/MemberQuestionnaire')
);
const PostSignUp = React.lazy(() => import('./beforeLogin/PostSignUp'));
// import ChatPage from "./afterLogin/ChatPage";
// import CoachDashboard from "./afterLogin/CoachDashboard";

export {
  AthleteProfile,
  // SignUp,
  Booking,
  CheckIn,
  ClientDashboard,
  ConfirmBookingPage,
  Details,
  Explore,
  FamilyMembers,
  Favorites,
  ForgotPassword,
  InstallmentsCardUpdate,
  MemberRegistration,
  MemberRegistrationCreateForm,
  MemberQuestionnaire,
  PaymentPage,
  PostBookingConfirmation,
  PostSignUp,
  PublicBooking,
  RescheduleAppointment,
  SignIn,
  Waiver,
  SavedCards,
  Credits,
  Orders,
};
